import useHelpModal from 'components/HelpModal/useHelpModal';
import { Phone } from 'lucide-react';

const BookACallButton: React.FunctionComponent = function () {
  const { showHelpModal } = useHelpModal();
  return (
    <button
      type="button"
      id="book-a-call"
      onClick={showHelpModal}
      className="w-full px-4 py-3 bg-purple-300 hover:bg-purple-400 transition-all rounded-full flex flex-row gap-x-3 justify-center text-14-22-em text-neutral-000"
    >
      <Phone size={20} className="my-auto" />
      <p>Give us a call</p>
    </button>
  );
};

export default BookACallButton;
